import type { TypedTypePolicies } from 'owa-graph-schema-type-policies';

export const createBootPolicies = (): TypedTypePolicies => ({
    UserConfiguration: {
        fields: {
            UserOptions: {
                merge(existing, incoming) {
                    if (existing) {
                        return { ...existing, ...incoming };
                    } else {
                        return incoming;
                    }
                },
            },
        },
    },
});
